import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { JourneysIcon, DashboardIcon } from '@shared/ui/icons';

const Journeys = lazy(() => import('@pages/journeys'));
const JourneyBuilder = lazy(() => import('@pages/journey-builder'));

// Programs are an account module (design spec 2026-09-14): the API grants
// PROGRAM_* bits only while `accountPermissions.enablePrograms` is on,
// and they arrive with the session metadata / JWT — a clinic user sees
// the menu after the next sign-in. The session metadata carries no
// account flags, so the bits are the only client-side signal.
const JOURNEY_ROUTE_LIST = {
  path: '/:currentAccountUuid/journeys',
  exact: true,
  additional: {
    component: Journeys,
    protected: true,
    title: i18next.t('titles:journeys'),
    icon: JourneysIcon,
    permission: permissions.PROGRAMS_GET,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.journeys || 'Programs',
    },
  },
};

const JOURNEY_ROUTE_PROGRAM_CREATE = {
  path: '/:currentAccountUuid/journeys/programs/create',
  exact: true,
  parentRoute: JOURNEY_ROUTE_LIST,
  additional: {
    component: JourneyBuilder,
    builderMode: 'create',
    protected: true,
    title: i18next.t('titles:journeys'),
    icon: DashboardIcon,
    permission: permissions.PROGRAM_CREATE,
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/journeys',
      label: ({ state }) => state.i18n?.en?.journeys?.builderCreateTitle || 'Create Program Template',
    },
  },
};

const JOURNEY_ROUTE_PROGRAM_EDIT = {
  path: '/:currentAccountUuid/journeys/programs/:definitionUuid/edit',
  exact: true,
  parentRoute: JOURNEY_ROUTE_LIST,
  additional: {
    component: JourneyBuilder,
    builderMode: 'edit',
    protected: true,
    title: i18next.t('titles:journeys'),
    icon: DashboardIcon,
    permission: permissions.PROGRAM_PATCH,
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/journeys',
      label: ({ state }) => state.i18n?.en?.journeys?.builderEditTitle || 'Edit Program Template',
    },
  },
};

const JOURNEY_ROUTE_PROGRAM_VIEW = {
  path: '/:currentAccountUuid/journeys/programs/:definitionUuid/view',
  exact: true,
  parentRoute: JOURNEY_ROUTE_LIST,
  additional: {
    component: JourneyBuilder,
    builderMode: 'view',
    protected: true,
    title: i18next.t('titles:journeys'),
    icon: DashboardIcon,
    permission: permissions.PROGRAM_GET,
    breadcrumb: {
      isRoot: false,
      parentPath: '/:currentAccountUuid/journeys',
      label: ({ state }) => state.i18n?.en?.journeys?.builderViewTitle || 'Program Template',
    },
  },
};

export const JOURNEY_ROUTES = {
  list: JOURNEY_ROUTE_LIST,
  programCreate: JOURNEY_ROUTE_PROGRAM_CREATE,
  programEdit: JOURNEY_ROUTE_PROGRAM_EDIT,
  programView: JOURNEY_ROUTE_PROGRAM_VIEW,
};
